import React from "react";
import { Plus } from "lucide-react";
import { Button } from "../ui/button";
import { Badge } from "../ui/badge";
import { ScrollArea } from "../ui/scroll-area";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "../ui/sheet";

export function ClauseSheet({ open, onOpenChange, clauses, addedClauseIds, onAddClause }) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent>
        <SheetHeader>
          <SheetTitle>Clause Library</SheetTitle>
        </SheetHeader>
        <ScrollArea className="h-[calc(100vh-200px)] mt-4">
          <div className="space-y-3">
            {clauses.length > 0 ? (
              clauses.map((clause) => {
                const isAdded = addedClauseIds.has(clause.id);
                return (
                  <div
                    key={clause.id}
                    className={`p-4 border rounded-sm ${isAdded ? "border-emerald-500 bg-emerald-50 dark:bg-emerald-900/20" : ""}`}
                  >
                    <div className="flex items-start justify-between mb-2">
                      <div>
                        <p className="font-medium">{clause.name}</p>
                        <Badge variant="outline" className="text-xs mt-1">{clause.category}</Badge>
                      </div>
                      {isAdded ? (
                        <Badge className="bg-emerald-500">Added</Badge>
                      ) : (
                        <Button size="sm" variant="outline" onClick={() => onAddClause(clause)} className="rounded-sm">
                          <Plus size={14} className="mr-1" /> Add
                        </Button>
                      )}
                    </div>
                    <p className="text-xs text-slate-500 line-clamp-2">{clause.content}</p>
                  </div>
                );
              })
            ) : (
              <p className="text-center text-slate-400 py-8">No clauses available</p>
            )}
          </div>
        </ScrollArea>
      </SheetContent>
    </Sheet>
  );
}
